import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Breadcrumbs, Button, EditButton } from "../components";
import useApiService from "../hooks/useApiService";

function CompanyTC() {
  const [data, setData] = useState({});
  const { get, post } = useApiService();

  const formatTimestamp = (timestamp) => {
    const date = timestamp.split("T")[0];
    const dateTimeString = `${new Date(timestamp)}`;
    const timeString = dateTimeString.split(" ")[4];
    const dateString = date.split("-").join("/");
    return `${dateString} ${timeString}`;
  };

  const fetchData = async () => {
    try {
      const response = await get("/api/config/tc");
      if (response.status && response.data) {
        const text = response.data.value;
        const timestamp = formatTimestamp(response.data.updated_at);
        setData({ text, timestamp });
      } else {
        throw new Error("Unable to fetch company terms and conditions");
      }
    } catch (error) {
      toast.error("Unable to fetch company terms and conditions");
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const [isEdit, setIsEdit] = useState(false);
  const [newTerms, setNewTerms] = useState("");
  const handleChange = (e) => {
    const { value } = e.target;
    setNewTerms(value);
    localStorage.setItem("new_company_terms", value);
  };

  const handleSubmit = async () => {
    try {
      const response = await post("/api/config/tc", { value: newTerms });
      if (response.status) {
        setNewTerms("");
        setIsEdit(false);
        await fetchData();
      } else {
        throw new Error("Error updating company terms and conditions");
      }
    } catch (error) {
      console.error("Error updating company terms" + error);
    }
  };

  useEffect(() => {
    if (isEdit) setNewTerms(data.text);
  }, [isEdit]);

  const breadcrumbs = [{ name: "Company Terms & Conditions" }];

  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className="column">
        <div className="section_title_wrapper">
          <h2 className="section_title">Company Terms & Conditions</h2>
          <EditButton onClick={() => setIsEdit(true)} />
        </div>
        <div className="tc_wrapper">
          <div className="tc_text">
            {isEdit ? (
              <textarea
                name="new_terms"
                placeholder="Enter Company Terms & Conditions"
                className="input_textarea"
                required
                onChange={handleChange}
                value={newTerms}
                rows={30}
              />
            ) : (
              <pre>{data.text}</pre>
            )}
          </div>
          {isEdit ? (
            <div className="row end">
              <Button className="ghost_outline_round" onClick={() => setIsEdit(false)}>
                Cancel
              </Button>
              <Button className="cta" onClick={handleSubmit}>
                Save
              </Button>
            </div>
          ) : (
            <div className="tc_timestamp">
              <span>Last Updated on:</span>
              <span>{data.timestamp}</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default CompanyTC;
